import React, {useState} from 'react';
import useTitle from '../../useTitle';
import '../TarievenPage/Styles.css';
import { Link } from 'react-router-dom';  // Import Link from react-router-dom
import ContactSection from '../ContactSection/Index';

const Tarieven = () => {
    useTitle("Tarieven");
    // eslint-disable-next-line no-unused-vars
          const [isOpen, setIsOpen] = useState(false);
          // Close the navbar when a link is clicked
          const handleLinkClick = (url) => {
              setIsOpen(false); // Close the navbar
              window.location.href = url; // Force navigation to the specific URL
          };
  return (
    <>
      <div className='tarievenContainer'>

        <div className='tarievenTitleContainer'>
          <h1 className='tarievenTitle'>Tarieven Mindful Breaks</h1>
        </div>

        <div className='tarievenDescriptionContainer'>
          <p>Een fitter, scherper en gelukkiger team? Het kan.
          Stel je voor: medewerkers die met meer focus, energie en ontspanning hun werkdag doorkomen.<br/>Yoga op de werkvloer helpt niet alleen om stress te verminderen, maar bevordert ook productiviteit en welzijn.</p>
          <br />
          <p>Maar niet alleen bedrijven profiteren van yoga op locatie.
          Wil je liever in alle rust en op je eigen tempo aan jezelf werken? Yoga aan huis is perfect voor wie op zoek is naar persoonlijke begeleiding en een les op maat. Of je nu beginner bent of al ervaring hebt — privélessen helpen je om dieper in je practice te duiken en volledig af te stemmen op jouw lichaam en behoeften.</p>
          <br />
          <p>Mindful Breaks biedt yogalessen op locatie zowel voor bedrijven als privé. Bekijk hieronder alle tarieven voor Yoga voor bedrijven én Privélessen.</p>
        </div>

        <div className='tarievenYogaAanHuisTitleSection'>
          <h1 className='tarievenYogaAanHuisTitle'>Privélessen</h1>
        </div>

        <div className='tarievenYogaAanHuisSection'>
            <div className="tarievenSection">
                <div className="tarievenOne">
                <h3 className='tarievenOneTitleDescription'>Privéles 60 minuten</h3>
                </div>
                <div className="tarievenTwo">
                  <h2 className='tarievenOnePriceDescription'>€ 60 / max 2 personen</h2>
                </div>
                <div className="tarievenThree">
                  <p>incl. materialen</p>
                </div>
                <div className="tarievenFour">
                  <p>excl. reiskosten*</p>
                </div>
            </div>

            <div className="tarievenSection">
              <div className="tarievenOne">
                <h3 className='tarievenOneTitleDescription'>Privéles 90 minuten</h3>
              </div>
              <div className="tarievenTwo">
                  <h2 className='tarievenOnePriceDescription'>€ 75 / max 2 personen</h2>
              </div>
              <div className="tarievenThree">
                  <p>incl. materialen</p>
              </div>
              <div className="tarievenFour">
                <p>excl. reiskosten*</p>
              </div>
            </div>
        </div>

        <div className='tarievenYogaAanHuisSection'>
            <div className="tarievenSection">
                <div className="tarievenOne">
                <h3 className='tarievenOneTitleDescription'>5-beurtenkaart (3 maanden geldig)</h3>
                </div>
                <div className="tarievenTwo">
                  <h2 className='tarievenOnePriceDescription'>vanaf € 275</h2>
                </div>
                <div className="tarievenThree">
                  <p>incl. materialen</p>
                </div>
                <div className="tarievenFour">
                  <p>excl. reiskosten*</p>
                </div>
            </div>

            <div className="tarievenSection">
              <div className="tarievenOne">
                <h3 className='tarievenOneTitleDescription'>10-beurtenkaart (6 maanden geldig)</h3>
              </div>
              <div className="tarievenTwo">
                  <h2 className='tarievenOnePriceDescription'>vanaf € 520</h2>
              </div>
              <div className="tarievenThree">
                  <p>incl. materialen</p>
              </div>
              <div className="tarievenFour">
                <p>excl. reiskosten*</p>
              </div>
            </div>
        </div>

        <div className='tarievenYogaOpHetWerkTitleSection'>
          <h1 className='tarievenYogaOpHetWerkTitle'>Yoga voor bedrijven</h1>
        </div>

        <div className='tarievenYogaAanHuisSection'>
            <div className="tarievenSection">
                <div className="tarievenOne">
                <h3 className='tarievenOneTitleDescription'>Losse yoga sessie</h3>
                </div>
                <div className="tarievenTwo">
                  <h2 className='tarievenOnePriceDescription'>vanaf € 165 /per sessie</h2>
                </div>
                <div className="tarievenThree">
                  <p>incl. benodigdheden voor <br/> max. 15 personen (meer is mogelijk)</p>
                </div>
                <div className="tarievenFour">
                  <p>excl. reiskosten*</p>
                </div>
            </div>

            <div className="tarievenSection">
              <div className="tarievenOne">
                <h3 className='tarievenOneTitleDescription'>5 sessies of meer</h3>
              </div>
              <div className="tarievenTwo">
                  <h2 className='tarievenOnePriceDescription'>vanaf € 150 /per sessie</h2>
              </div>
              <div className="tarievenThree">
                  <p>incl. benodigdheden voor <br/> max. 15 personen (meer is mogelijk)</p>
              </div>
              <div className="tarievenFour">
                  <p>excl. reiskosten*</p>
              </div>
            </div>
        </div>

        <div className='reisKostenContainer'>
          <p>*De reiskosten bedragen €0,35 per km.</p>
        </div>

        <div className='extraInfoTitleContainer'>
          <h1 className='extraInfoTitle'>Iets anders in gedachten?</h1>
        </div>

        <div className='extraInfoDescription'>
          <p>Andere wensen, ideeën voor een workshop of samenwerking? Dit kan zeker! Ik hoor het graag en maak een offerte op maat.</p>
        </div>

        <div className='ideeButtonContainer'>
          <Link onClick={() => handleLinkClick('/contact')}  className='ideeButtonContact'>Stuur je idee door!</Link>
        </div>
        
      </div>

      {/* Contact/Menu Section */}
      <ContactSection />
    </>
  )
}

export default Tarieven;